import { staticBooleanFiltersMapping } from 'utils/submissions';
import FilterItems from './FilterItems';
import FilterValues from './FilterValues';


const FilterOptions = ({
  isFieldDropdownOpen,
  isValueDropdownOpen,
  selectedField,
  handleFieldSelect,
  closeAllDropdowns
}) => {
  if (!isFieldDropdownOpen && !isValueDropdownOpen) return null;

  return (
    <div className="absolute top-full left-0 mt-2 flex z-50">
      <div className="w-48 border-r border-[#85869833]">
        <FilterItems openDropdown={isFieldDropdownOpen} fieldClickHandler={handleFieldSelect} />
      </div>

      {isValueDropdownOpen && selectedField && (
        <div className="w-48">
          <FilterValues
            openDropdown={true}
            selectedField={selectedField.value}
            optionsLabelMapping={staticBooleanFiltersMapping?.[selectedField?.value]}
            closeFilterDropdown={closeAllDropdowns}
          />
        </div>
      )}
    </div>
  );
};

export default FilterOptions